import isFunction from 'lodash/isFunction';

/**
 * Truncates a string to the given length.
 * @param {string} string
 * @param {number} length
 * @param {string} ellipsis
 * @return {string}
 */
export const truncate = (string, length, ellipsis = '…') => {
    if (string.length <= length) return string;
    return string.substr(0, length) + ellipsis;
};

export const SHY = '\u00ad';

export const hyphenize = text => {
    if (text && text.replace && isFunction(text.replace)) {
        return text.replace(/--/g, SHY);
    }

    return text;
};



// WEBPACK FOOTER //
// ./scripts/utils/text.js